import React, { ReactElement } from 'react'
import { TextField } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'

type FormFieldProps = {
  field: any
}

export let CourseCodeField = ({ field }: FormFieldProps): ReactElement => (
  <TextField
    label="Course Code"
    name={field.name}
    value={field.state.value}
    onChange={(e) => field.handleChange(e.target.value)}
    onBlur={field.handleBlur}
    fullWidth
    sx={{ bgcolor: 'background.paperDark' }}
  />
)

export let DateField = ({
  field,
  label,
}: {
  field: any
  label: string
}): ReactElement => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      label={label}
      value={field.state.value ? dayjs(field.state.value) : null}
      onChange={(val) =>
        field.handleChange(val ? val.format('YYYY-MM-DD') : '')
      }
      onClose={field.handleBlur}
      slotProps={{
        textField: {
          fullWidth: true,
          sx: { bgcolor: 'background.paperDark' },
          onBlur: field.handleBlur,
        },
      }}
    />
  </LocalizationProvider>
)

export let NotesField = ({ field }: FormFieldProps): ReactElement => (
  <TextField
    label="Notes"
    name={field.name}
    value={field.state.value}
    onChange={(e) => field.handleChange(e.target.value)}
    onBlur={field.handleBlur}
    multiline
    rows={3}
    fullWidth
    sx={{ bgcolor: 'background.paperDark' }}
    placeholder="Add any notes or comments about this pending accreditation"
  />
)
